import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DateTimeValidationError, PickerChangeHandlerContext } from
  '@mui/x-date-pickers/models';
import dayjs, { Dayjs } from 'dayjs';

interface DateTimePickerProps {
  value: Dayjs | null;
  onChange: (value: Dayjs | null, context: PickerChangeHandlerContext<DateTimeValidationError>) => void;
}

// Define the allowed hours in 24-hour format
const allowedHours = [9, 11, 13, 15, 17]; // 9 AM, 11 AM, 1 PM, 3 PM, 5 PM

export default function Date_TimePicker({ value, onChange }: Partial<DateTimePickerProps>) {
// Get the current date and time to use as the minimum allowed date
  const now = dayjs();
  // Disable Saturdays and Sundays
  const shouldDisableDate = (date: Dayjs) => {
    return date.day() === 0 || date.day() === 6; // 0 is Sunday, 6 is Saturday
  };

  
  // Enhance the onChange handler to perform validation
  const handleDateTimeChange = (
    newValue: Dayjs | null,
    context: PickerChangeHandlerContext<DateTimeValidationError>
  ) => {
    if (newValue) {
      const selectedHour = newValue.hour();
      const selectedMinute = newValue.minute();

      // Check if the selected hour is in the allowed list
      if (!allowedHours.includes(selectedHour)) {
        console.warn("Selected time is not in the allowed slots (9 AM, 11 AM, 1 PM, 3 PM, 5 PM).");
        // Optionally, you could set the value to null or a default valid time,
        // or trigger an error state. For now, we'll let the original onChange proceed
        // but log a warning. The picker itself should visually guide the user.
        // Or you could return early without calling the original onChange if you want
        // to strictly prevent invalid selections from being passed up.
        // Example to strictly prevent:
        // return;
      }
      // You can add more specific minute validation here if needed
      // For instance, if you only want :00 for these hours:
      if (selectedMinute !== 0) {
          console.warn("Only :00 minutes are allowed for the selected hour.");
          // return; // To strictly prevent
      }
    }

    // Call the original onChange prop
    onChange?.(newValue, context);
  };


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker']}>
        <DateTimePicker
          label="Choose date and time"
          value={value}
          // Use shouldDisableTime to restrict selectable hours and minutes
          shouldDisableTime={(value, view) => {
            if (view === 'hours') {
              return !allowedHours.includes((value as Dayjs).hour());
            }
            if (view === 'minutes') {
              return (value as Dayjs).minute() !== 0;
            }
            return false;
          }}
          minDate={now} 
          onChange={handleDateTimeChange} // Use our enhanced handler
          shouldDisableDate={shouldDisableDate} // Disables weekends
        
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}